export const enPatientTabsTranslations = {
  patientTabs: {
    overview: 'Overview',
    profile: 'Profile',
    progressNote: 'Progress Note',
    patientNote: 'Patient Notes',
    data: 'Data',
    courses: 'Home Exercise Program',
    documentation: 'Documentation',
    generalInfo: 'Administrative',
    clinicalEvents: 'Reported Events',
    timeline: 'Timeline',
    rtm: 'RTM',
    activityLog: 'Progress',
    balanceDemo: 'Balance (Demo)',
    events: 'Events',
  },
  dischargedPatient: {
    description: `You’re now viewing a discharged patient - they do not have an active
        episode of care. To assign the patient a new episode of care, `,
    navigateToPatientProfile: `navigate to the patient's profile.`,
    goToPatientProfile: `Go to patient’s profile`,
  },
};
